import { t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';
import { ReportHistory } from '@/components/raven/report-history';
import { OLink } from '@/components/raven/shared';
export const ReportsPage = () => {
  useLocale();
  return (
    <main className="raven-page">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <span className="raven-label">{t('workspace.reports')}</span>
          <h1>{t('workspace.allReports')}</h1>
          <p>{t('auth.viewAndManageTheReportsYouAreResponsibleFor')}</p>
        </div>
        <OLink className="rounded bg-[#222e9c] px-4 py-3 text-sm text-white" to="/reports/create">
          {t('auth.generateNewReport2')}{' '}
        </OLink>
      </div>
      <section className="mt-8">
        <ReportHistory />
      </section>
    </main>
  );
};
